import { html } from '../core/html.js';
import { t, getLanguage } from '../core/i18n.js';
import { routeHref } from '../core/url.js';
import { icon } from './icon.js';

const pad = (value) => String(value).padStart(2, '0');

export const legalToc = ({ titleKey, items, meta }) => html`
  <aside class="legal__toc">
    <p class="legal__toc-title">${t(titleKey)}</p>
    <ol>
      ${items.map(
        (item, index) => html`
          <li>
            <a href="#${item.id}">
              <span class="legal__toc-num" aria-hidden="true">${pad(index + 1)}</span>
              <span>${t(item.titleKey)}</span>
            </a>
          </li>
        `,
      )}
    </ol>
    <p class="legal__toc-meta">${meta}</p>
  </aside>
`;

export const legalSection = ({ id, iconName = 'check', titleKey, body }) => html`
  <section class="legal__section" id="${id}">
    <h2>
      <span class="legal__icon" aria-hidden="true">${icon(iconName, { size: 16 })}</span>
      <span>${t(titleKey)}</span>
    </h2>
    ${body}
  </section>
`;

/** Non-German legal pages carry a translation, not the binding original. */
export const legalTranslationNotice = () =>
  getLanguage() === 'de'
    ? ''
    : html`<p class="legal__notice" role="note">${t('legal.translationNotice')}</p>`;

export const legalCta = () => html`
  <div class="legal__cta">
    <div>
      <h2>${t('cta.title')}</h2>
      <p>${t('cta.lede')}</p>
    </div>
    <a class="btn btn--ink" href="${routeHref('/contact')}">
      ${t('cta.contact')}${icon('arrowRight', { size: 16 })}
    </a>
  </div>
`;
